export const STATIC_PAGES_ACTION = {
	PAGES_LIST: 'PAGES_LIST',
	ARTICLES: 'ARTICLES',
	BANNERS: 'BANNERS',
}
